import * as yup from 'yup';

export const incomeNetWorthMapping = {
  1: { minNetWorth: 1000000, maxNetWorth: 500000000 },
  2: { minNetWorth: 1000000, maxNetWorth: 500000000 },
  3: { minNetWorth: 5000000, maxNetWorth: 500000000 },
  4: { minNetWorth: 10000000, maxNetWorth: 500000000 },
  5: { minNetWorth: 25000000, maxNetWorth: 500000000 }
};

const editSchema = yup.object({
  gender: yup
    .string('')
    .nullable()
    .required('Gender is required'),
  fatherOrSpouse: yup
    .string('')
    .required('Relation is required'),
  firstName: yup
    .string('First Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid First Name")
    .required('First Name is required'),
   pan: yup
    .string('PAN Number is required')
    .matches(/[A-Za-z]{3}[pP]{1}[A-Za-z]{1}\d{4}[A-Za-z]{1}/, "Enter valid PAN Number")
    .required('PAN is required'),
  middleName: yup
    .string('Middle Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid Middle Name"),
    // .required(localeText?.middleNameAsperPanRequired),
  lastName: yup
    .string('Last Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid Last Name"),
    // .required("Last Name is required"),
  fathersSpouseFirstName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name")
    .required('Relation First Name is required'),
  fathersSpouseMiddleName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
  fathersSpouseLastName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
    // .required('Relation Last Name is required'),
  maritialStatus: yup
    .string('')
    .nullable()
    .required('Marital Status is required'),
  mobile: yup
    .number('')
    .required('Mobile Number is required')
    .typeError("Invalid Number"),
  mobileRelation: yup
    .string('')
    .required('Mobile Relation is required'),
  email: yup
    .string('')
    .email('Enter a valid email')
    .required('Email is required'),
  emailRelation: yup
    .string('')
    .required('Email Relation is required'),
  anualIncomeRange: yup
    .string('')
    .required('Annual Income Range is required'),
  occupation: yup
    .string('')
    .required('Occupation is required'),
  tradingExp: yup
    .number('')
    .max(25, "Trading experience must be between 0 to 25").min(0, "Trading experience must be between 0 to 25")
    .typeError("Invalid entry"),
  politicalAffiliations: yup
    .string('')
    .required('Political Affiliations is required'),
  natureOfBusiness: yup
    .string('')
    .required('Nature of Business is required'),
  natureOfBusinessOther: yup
    .string('')
    .when('natureOfBusiness', {
      is: "5",
      then: yup.string('')
        .required('Other Nature of Business is required'),
      otherwise: yup.string('').notRequired()
    }),
  sourceOfWealth: yup
    .string('')
    .required('Source of Wealth is required'),
  placeOfBirth: yup
    .string('')
    .matches(/^[ a-zA-Z0-9]*$/, "Invalid entry")
    .required('Place of Birth is required'),
  countryOfBirth: yup
    .string('')
    .matches(/^[ a-zA-Z0-9]*$/, "Invalid entry")
    .required('Country of Birth is required'),
  fatcaDeclaration: yup
    .boolean(''),
  agreementOfConsents: yup
    .boolean(''),
  segment: yup
    .array('')
    .required('Segment selection is required'),
  networth: yup
    .number()
    .required("Net Worth is required")
    .test('is-valid-net-worth', function (value) {
      const { anualIncomeRange } = this.parent;
      const incomeRange = incomeNetWorthMapping[anualIncomeRange];

      if (!incomeRange) return true;

      const minNetWorth = 1;
      const maxNetWorth = incomeRange.maxNetWorth;

      const isValid = value >= minNetWorth && value <= maxNetWorth;
      return isValid || this.createError({ message: incomeRange.errorMessage });
  }),
  networthDate: yup
    .number()
    .required("Net Worth As On Date is Required"),

});

const nonEditSchema = yup.object({
  fatherOrSpouse: yup
    .string('')
    .required('Relation is required'),
  firstName: yup
    .string('First Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid First Name")
    .required('First Name is required'),
  pan: yup
    .string('PAN Number is required')
    .matches(/[A-Za-z]{3}[pP]{1}[A-Za-z]{1}\d{4}[A-Za-z]{1}/, "Enter valid PAN Number")
    .required('PAN Number is required'),
  middleName: yup
    .string('Middle Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid Middle Name"),
    // .required(localeText?.middleNameAsperPanRequired),
  lastName: yup
    .string('Last Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid Last Name"),
    // .required("Last Name is required"),
  fathersSpouseFirstName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name")
    .required('Relation First Name is required'),
  fathersSpouseMiddleName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
  fathersSpouseLastName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
    // .required('Relation Last Name is required'),
  maritialStatus: yup
    .string('')
    .nullable()
    .required('Marital Status is required'),
  anualIncomeRange: yup
    .string('')
    .required('Annual Income Range is required'),
  occupation: yup
    .string('')
    .required('Occupation is required'),
  tradingExp: yup
    .number('')
    .max(25).min(0, "Trading experience must be between 0 to 99")
    .typeError("Invalid entry"),
  politicalAffiliations: yup
    .string('')
    .required('Political Affiliations is required'),
  natureOfBusiness: yup
    .string('')
    .required('Nature of Business is required'),
  natureOfBusinessOther: yup
    .string('')
    .when('natureOfBusiness', {
      is: "5",
      then: yup.string('')
        .required('Other Nature of Business is required'),
      otherwise: yup.string('').notRequired()
    }),
  sourceOfWealth: yup
    .string('')
    .required('Source of Wealth is required'),
  fatcaDeclaration: yup
    .boolean(''),
  isAgreeToConcent: yup
    .boolean(''),
  segment: yup
    .array('')
    .required('Segment selection is required'),
    networth: yup
    .number()
    .required("Net Worth is required")
    .test('is-valid-net-worth', function (value) {
      const { anualIncomeRange } = this.parent;
      const incomeRange = incomeNetWorthMapping[anualIncomeRange];

      if (!incomeRange) return true;

      const minNetWorth = 1;
      const maxNetWorth = incomeRange.maxNetWorth;

      const isValid = value >= minNetWorth && value <= maxNetWorth;
      return isValid || this.createError({ message: incomeRange.errorMessage });
  }),
  networthDate: yup
    .number()
    .required("Net Worth As On Date is Required"),
});

export const getValidationSchema = (isEdit) => {
  return (
      isEdit ? editSchema : nonEditSchema
    ) 
}
